<!--
component: ZoomImageViewer
author: Ken Nakamura
description: 部分拡大画像表示コンポーネント
-->
<template>
  <section class="zoom-image-viewer scroll-hidden">
    <v-img
      id="zoom-img"
      :src="imageUrl"
      contain :height="imgHeight" :width="imgWidth"
      :style="{'transform': `scale(${scale})`}"
      @load="imageLoaded"
      position="center center"
    >
    </v-img>
  </section>
</template>

<script>

export default {
  data() {
    return {
      scale: 0,
      targetView: null,
      zoomView: null,
      wratio: 1,
      hratio: 1,
      imgWidth: '100%',
      imgHeight: '100%',
    }
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    sourceWidth: {
      type: Number,
      default: 1,
    },
    sourceHeight: {
      type: Number,
      default: 1,
    },
    targetViewId: {
      type: String,
      default: 'img',
    },
    zoom: {
      type: Number,
      default: 1,
    },
    centerx: {
      type: Number,
      default: 0,
    },
    centery: {
      type: Number,
      default: 0,
    }
  },
  mounted () {
    this.initImageSize();
  },
  watch:{
    zoom: {
      immediate: true,
      handler(value) {
        this.scale = value;
      }
    },
    sourceWidth: {
      immediate: true,
      handler() {
        this.initImageSize();
      }
    },
    sourceHeight: {
      immediate: true,
      handler() {
        this.initImageSize();
      }
    },
    centerx: {
      immediate: true,
      handler(value) {
        if (this.zoomView) {
          let xoffset = 0;
          //const zwr = this.zoomView.clientWidth / this.sourceWidth;
          //const zhr = this.zoomView.clientHeight / this.sourceHeight;
          //const twr = this.targetView.clientWidth / this.sourceWidth;
          //const thr = this.targetView.clientHeight / this.sourceHeight;
          let act_zw = this.zoomView.clientWidth;
          let act_tw = this.targetView.clientWidth;
          /*
          if (twr > thr) {
            act_tw = this.sourceWidth * thr;
          }
          if (zwr > zhr) {
            act_zw = this.sourceWidth * zhr;
            xoffset = (this.zoomView.clientWidth - act_zw) / 2;
          }
          */
          this.wratio = act_zw / act_tw;
          const x = (this.zoomView.clientWidth * this.zoom ) / 2 + xoffset - value * this.zoom * this.wratio;
          this.zoomView.style.left = x + 'px';
        }
      }
    },
    centery: {
      immediate: true,
      handler(value) {
        if (this.zoomView) {
          let yoffset = 0;
          //const zwr = this.zoomView.clientWidth / this.sourceWidth;
          ///const zhr = this.zoomView.clientHeight / this.sourceHeight;
          //const twr = this.targetView.clientWidth / this.sourceWidth;
          //const thr = this.targetView.clientHeight  this.sourceHeight;
          let act_zh = this.zoomView.clientHeight;
          let act_th = this.targetView.clientHeight;
          /*
          if (twr < thr) {
            act_th = this.sourceHeight * twr;
          }
          if (zwr < zhr) {
            act_zh = this.sourceHeight * zwr;
            yoffset = (this.zoomView.clientHeight - act_zh) / 2;
          }
          */
          this.hratio = act_zh / act_th;
          let y = (this.zoomView.clientHeight * this.zoom) / 2 + yoffset - value * this.zoom * this.hratio;
          //let y = this.zoomView.clientHeight * this.zoom / 2 - value * this.zoom / 3;
          this.zoomView.style.top = y + 'px';
        }
      }
    },
  },
  computed: {
  },
  methods: {
    imageLoaded() {
      if (this.zoomView && this.targetView) {
        this.wratio = this.zoomView.clientWidth / this.targetView.clientWidth;
        // この時点でもまだ zoomView.clientHeightが確定していない -> watch centery で改めて取得する必要がある
        this.hratio = this.zoomView.clientHeight / this.targetView.clientHeight;
      }
    },
    initImageSize() {
      this.zoomView = document.getElementById('zoom-img');
      this.targetView = document.getElementById(this.targetViewId);
      //
      if (this.zoomView && this.zoomView.parentElement && this.sourceWidth && this.sourceHeight) {
        const parent = this.zoomView.parentElement;
        const wratio = parent.clientWidth / this.sourceWidth;
        const hratio = parent.clientHeight / this.sourceHeight;
        if (wratio > hratio) {
          const w = parent.clientHeight * this.sourceWidth / this.sourceHeight;
          this.imgWidth = w + 'px';
          if (this.$store.state.mode == 7) {
            this.imgHeight = (parent.clientHeight + 25) + 'px';
          }
          else {
            this.imgHeight = parent.clientHeight + 'px';
          }
        }
        else {
          const h = parent.clientWidth * this.sourceHeight / this.sourceWidth;
          this.imgWidth = parent.clientWidth + 'px';
          if (this.$store.state.mode == 7) {
            this.imgHeight = (h + 25) + 'px';
          }
          else {
            this.imgHeight = h + 'px';
          }
        }
      }
    },
  },  
}
</script>
<style lang="scss" scoped>
.scroll-hidden {
	overflow: hidden;
}
</style>